<template>
	<div>
		<template v-for="network in networks">
			<ShareNetwork
				:network="network.network"
				:key="network.network"
				:style="{ backgroundColor: network.color }"
				class="social-sharing"
				:url="url"
				:title="title"
				:description="description"
			>
				<v-icon color="white" class="mr-1">{{ network.icon }}</v-icon>
				<span>{{ network.name }}</span>
			</ShareNetwork>
		</template>
		
		<!--:title="formatTitle(title, network.network)"-->
		
		<!-- Altre props -->
		<!--:twitterUser="sharing.twitterUser"-->
		<!--:hashtags="sharing.hashtags"-->
		<!--:quote="sharing.quote"-->
	</div>
</template>

<script>
export default {
	props: ['url', 'description', 'title'],
	data () {
		return {
			sharing: {
				// url: null,
				// title: 'Click Day',
				// description: '',
				// quote: 'The hot reload is so fast it\'s near instant. - Evan You',
				// hashtags: 'vuejs,vite,javascript',
				// twitterUser: 'youyuxi'
			},
			networks: [
				{ network: 'email', name: 'Email', icon: 'mdi-email', color: '#333333' },
				// { network: 'sms', name: 'SMS', icon: 'far fah fa-lg fa-comment-dots', color: '#333333' },
				{ network: 'telegram', name: 'Telegram', icon: 'fab fah fa-lg fa-telegram-plane', color: '#0088cc' },
				{ network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366' },
			]
		}
	},
	
	methods: {
		formatTitle(title, network) {
			if (network == 'telegram') return `**${title}**`
			else if (network == 'whatsapp') return `*${title}*`
		}
	}
}
</script>

<style scoped>
	.social-sharing {
      color: #FFFFFF;
      background-color: #333;
      border-radius: 3px;
      overflow: hidden;
			display: inline-block;
      cursor: pointer;
      margin: 0 10px 10px 0;
			padding: 5px 10px;
      text-decoration: none;
	}
</style>